import * as React from "react";
import * as ReactRedux from "react-redux";

import { selectors, actions, LabExample } from "../reducers/lab";

import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Menu, MenuItem } from "material-ui/Menu";

import HistoryIcon from "./Lab/RequestHistoryIcon";
import CloseIcon from "material-ui/svg-icons/navigation/close";

interface LabExampleSwitcherContainerProps {
	examplesType: string;
}

interface LabExampleSwitcherProps extends LabExampleSwitcherContainerProps {
	exampleHistory: LabExample[];

	deleteExample(exampleIndex: number);
	loadExampleFromHistory(example: LabExample);
}

class LabExampleSwitcher extends React.Component<LabExampleSwitcherProps> {
	state = {
		isPopoverOpen: false,
	};

	private labelElement: HTMLElement;

	togglePopover() {
		this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
	}

	loadExampleFromHistory(example: LabExample) {
		this.setState({ isPopoverOpen: false }); // close popover
		this.props.loadExampleFromHistory(example);
	}

	deleteExample(e: Event, exampleIndex: number) {
		e.stopPropagation();

		this.setState({ isPopoverOpen: false }); // close popover
		this.props.deleteExample(exampleIndex);
	}

	render() {
		const { isPopoverOpen } = this.state;
		const { exampleHistory } = this.props;

		return (
			<div
				style={{
					display: "inline-flex",
					alignItems: "center",
					marginRight: "3rem",
				}}
			>
				<div
					ref={el => (this.labelElement = el)}
					onClick={this.togglePopover.bind(this)}
					style={{
						display: "inline-flex",
						alignContent: "center",
						cursor: "pointer",
						fontSize: "0.75rem",
						fontWeight: 700,
						color: "#414042",
					}}
				>
					<HistoryIcon
						style={{
							height: "22px",
							marginRight: "0.75rem",
						}}
					/>

					<p
						style={{
							display: "inline-block",
							margin: 0,
							lineHeight: "22px",
						}}
					>
						EXAMPLE HISTORY
					</p>
				</div>

				<Popover
					open={isPopoverOpen}
					anchorEl={this.labelElement}
					anchorOrigin={{
						horizontal: "left",
						vertical: "bottom",
					}}
					targetOrigin={{
						horizontal: "left",
						vertical: "top",
					}}
					onRequestClose={this.togglePopover.bind(this)}
					style={{
						marginTop: 7,
					}}
					animation={PopoverAnimationVertical}
				>
					<Menu style={{ minWidth: 175 }}>
						{!Object.values(exampleHistory).length && (
							<MenuItem primaryText={<em>- No Examples Tried -</em>} />
						)}
						{Object.values(exampleHistory).map((example, i) => (
							<MenuItem
								key={example.key}
								rightIcon={
									<CloseIcon
										hoverColor="red"
										style={{
											width: "38px",
											height: "48px",
											margin: 0,
											padding: "17px 12px",
										}}
										onClick={e => this.deleteExample(e, i)}
									/>
								}
								onClick={this.loadExampleFromHistory.bind(this, example)}
							>
								<p
									style={{
										display: "inline-block",
										textTransform: "uppercase",
										fontFamily: "Rajdhani",
										margin: 0,
									}}
								>
									{example.meta.docTitle} /
								</p>

								<p
									style={{
										margin: 0,
										marginLeft: "0.5rem",
										display: "inline-block",
									}}
								>
									{example.meta.heading}
								</p>
							</MenuItem>
						))}
					</Menu>
				</Popover>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps: LabExampleSwitcherContainerProps) => ({
	exampleHistory: selectors.selectExampleHistory(state, ownProps.examplesType),
});

const mapDispatchToProps = {
	deleteExample: actions.deleteExample,
	loadExampleFromHistory: actions.loadExampleFromHistory,
};

// note: as any is a cheap hack... not sure why the "style" prop is causing problems
export default ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(LabExampleSwitcher);



// WEBPACK FOOTER //
// ./src/components/LabExampleSwitcher.tsx